const RootLayout         = require('./RootLayout.jsx');
const ChallengePage      = require('./pages/ChallengePage.jsx');
const FingerprintOverlay = require('./pages/FingerprintOverlay.jsx');
const ForbiddenPage      = require('./pages/ForbiddenPage.jsx');
const NotFoundPage       = require('./pages/NotFoundPage.jsx');

const pageLoader = ({ context }) => context?.pageData ?? {};

const routes = [
    {
        path     : '/',
        component: RootLayout,
        children : [
            { path: 'loading', Component: FingerprintOverlay, loader: pageLoader },
            { path: 'challenge', Component: ChallengePage, loader: pageLoader },
            { path: 'forbidden', Component: ForbiddenPage },
            { path: 'notFound', Component: NotFoundPage, loader: pageLoader },
            { path: '*', Component: NotFoundPage, loader: pageLoader },
        ]
    }
];
module.exports = routes;